import React from 'react'
import Onboard from './Onboard'

const index = () => <Onboard/>

export default index